<script>
  import { merchant } from "@store"
</script>

<div class="outside py-8 md:py-16 min-h-screen">
  {#if ["logo", "both"].includes($merchant.theme.branding) && $merchant.image.url}
    <header class="flex justify-center mb-6">
      <img src={$merchant.image.url} alt="{$merchant.name} logo" class="max-w-[10rem] w-full" />
    </header>
  {/if}

  <main>
    <slot />
  </main>
</div>
